__webpack_require__.p = "https://bmidxbukplprod.netlify.app/";